<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import InboxesAPI from 'dashboard/api/inboxes';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      apiToken: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    apiToken: { required },
  },
  methods: {
    async validateAndCreate() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      const token = this.apiToken.trim();
      try {
        const { data: validateData } = await InboxesAPI.validateMaxBotToken(token);
        if (!validateData?.valid) {
          useAlert(this.$t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.VALIDATE_ERROR'));
          return;
        }
      } catch {
        useAlert(this.$t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.VALIDATE_ERROR'));
        return;
      }

      try {
        const payload = await this.$store.dispatch('inboxes/createChannel', {
          channel: {
            type: 'max_bot',
            api_token: token,
          },
        });
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: payload.id },
        });
      } catch (error) {
        useAlert(
          error?.message || this.$t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.CREATE_ERROR')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.DESC')"
    />
    <p class="mb-4 text-sm text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.ADVANTAGES') }}
    </p>
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="validateAndCreate"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$?.apiToken?.$error }">
          {{ $t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.API_TOKEN.LABEL') }}
          <input
            v-model="apiToken"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.API_TOKEN.PLACEHOLDER')"
            @blur="v$?.apiToken?.$touch"
          />
        </label>
      </div>
      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.MAX_BOT_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
